import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Report } from '../../../models/report.model';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PButtonComponent } from '../../../../shared/design-system/atoms/p-button/p-button.component';
import { PInputComponent } from '../../../../shared/design-system/atoms/p-input/p-input.component';
import { IconsModule } from '../../../../shared/design-system/icons/icons.module';

@Component({
  selector: 'app-les-moins-edit-mode',
  standalone: true,
  imports: [
    CommonModule,
    PButtonComponent,
    PInputComponent,
    IconsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './les-moins-edit-mode.component.html',
  styleUrl: './les-moins-edit-mode.component.scss',
})
export class LesMoinsEditModeComponent {
  @Input() drawbacks!: Report.Drawbacks;

  @Output() drawbacksChanged = new EventEmitter<Report.Drawbacks>();

  newDrawbacks!: Report.Drawbacks;

  drawbacksForm = new FormGroup({
    drawback: new FormControl(''),
  });

  get isAddDrawbackDisabled(): boolean {
    return (
      this.newDrawbacks.items.length >= 12 ||
      this.drawbacksForm.controls.drawback.value === ''
    );
  }

  get addDrawbackTitle(): string {
    if (this.newDrawbacks.items.length >= 12) {
      return 'Vous avez atteint le nombre maximum des moins';
    }

    if (this.drawbacksForm.controls.drawback.value === '') {
      return 'Veuillez saisir un moins';
    }

    return 'Ajouter';
  }

  get isMaxDrawbacksReached(): boolean {
    return this.newDrawbacks.items.length >= 12;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const currentDrawbacks = changes['drawbacks'].currentValue;
    if (currentDrawbacks) {
      this.newDrawbacks = currentDrawbacks;
    }
  }

  addDrawback(): void {
    const newDrawback = this.drawbacksForm.controls.drawback.value;
    if (newDrawback && newDrawback.length > 0) {
      this.newDrawbacks.items.push(newDrawback);

      this.drawbacksChanged.emit(this.newDrawbacks);
      this.drawbacksForm.controls.drawback.setValue('');
    }
  }

  deleteDrawback(drawback: string): void {
    this.newDrawbacks.items = this.newDrawbacks.items.filter(
      (p) => p !== drawback,
    );
    this.drawbacksChanged.emit(this.newDrawbacks);
  }
}
